import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureApi } from '@kss/api';
import { logout, refreshSession } from '@kss/auth';
import App from './App';
import { store } from './store';
import './index.css';

// Wire the auth token + unauthorized handler into the axios client.
configureApi({
  getToken: () => store.getState().auth.session?.token ?? null,
  getRefreshToken: () => store.getState().auth.session?.refreshToken ?? null,
  onRefreshed: (session) => store.dispatch(refreshSession({ ...store.getState().auth.session, ...session })),
  onUnauthorized: () => store.dispatch(logout('refresh-failed'))
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out + remove the launch splash once the app has mounted (no white flash). Idempotent.
function dismissSplash() {
  const splash = document.getElementById('app-splash');
  if (!splash) return;
  splash.classList.add('hide');
  window.setTimeout(() => splash.remove(), 500);
}
// The splash is a full-screen z-9999 overlay, so if it's NOT dismissed it silently blocks every
// click in the app. requestAnimationFrame is the fast path when the tab is visible — but rAF is
// PAUSED for hidden/background tabs (and some webviews start hidden), which would leave the splash
// up forever. So also dismiss on a plain timeout (fires even when backgrounded) and whenever the
// tab becomes visible. All paths are idempotent.
requestAnimationFrame(() => requestAnimationFrame(dismissSplash));
window.setTimeout(dismissSplash, 1200);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') dismissSplash();
});
